<script>
  import { push } from "svelte-spa-router"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Button from "../../../../../Shared/button.svelte"
  import Footer from "../../../../../Shared/footer.svelte"

  /**
   * Starts a new process by creating new Document object.
   * @function startNew
   */
  const startNew = async () => {
    push(`/signing/multiSigner/docket`)
  }
</script>

<svelte:head>
  <title>Doc Multi-Signer</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="mx-auto h-auto w-full max-w-[920px] pb-40 pt-3">
      <div class="mt-6 flex min-h-[470px] w-full flex-col justify-between rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
        <div class=" select-none space-y-3 opacity-100">
          <h1 class="leading text-3xl font-bold dark:text-white mobile:text-5xl">
            Doc
            <br />
            Multi-Signer
          </h1>

          <div class="w-full sm:w-3/5">
            <p class="break-words text-justify text-sm text-gray-500 dark:text-gray-300 mobile:text-base">Sign documents seamlessly with eSign, Aadhaar ESign, and Digital Signing. Effortlessly publish and share secure, blockchain-verified documents. Ensure authenticity and trust with DocChain.io for all signed records.</p>
          </div>
        </div>

        <div class="flex items-center justify-end">
          <Button on:click={startNew} btnName={"Start"} leftIcon={"circle-play"} btnclr={"green"} />
        </div>
      </div>
    </div>
  </div>
  <Footer />
</div>

<style>
  .leading {
    line-height: 4rem;
  }
</style>
